export default function removeExt(fileName: string): string {
  return fileName.split(".")[0];
}
